import React from 'react';

/**
 * Computes the sidebar style based on the current state.
 * Desktop widths are CSS-driven via data-collapsible (full or icon rail).
 */
export function getSidebarStyle(
  isMobile: boolean,
  _open: boolean,
  openMobile: boolean
): React.CSSProperties {
  if (isMobile) {
    return {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100%',
      zIndex: 50,
      borderRight: 'none',
      transition: 'transform 0.3s ease-in-out',
      transform: openMobile ? 'translateX(0)' : 'translateX(-100%)',
    };
  }

  return {};
}
